import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=829f0c48&"
import script from "./Trend.vue?vue&type=script&lang=js&"
export * from "./Trend.vue?vue&type=script&lang=js&"
import style0 from "./Trend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports